var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterSupplyActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#5f9098"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.0997 65.3313C66.1164 69.8785 57.9178 72.3416 49.5 72.3416C41.0822 72.3416 32.8809 69.8785 25.8976 65.3313L22 69.2289C30.0659 74.7506 39.6747 77.755 49.5 77.755C59.3253 77.755 68.9341 74.7506 77 69.2289L73.0997 65.3313Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9357 66.9284C58.8922 66.9284 66.1759 59.6447 66.1759 50.6882C66.1759 42.4978 53.4923 26.439 52.0469 24.6363L49.9357 22L47.8245 24.6363C46.3764 26.439 33.6956 42.4978 33.6956 50.6882C33.6956 59.6447 40.9793 66.9284 49.9357 66.9284ZM49.9357 30.7534C54.7861 37.2279 60.7625 46.5632 60.7625 50.6882C60.7625 56.6592 55.9067 61.515 49.9357 61.515C43.9647 61.515 39.1089 56.6592 39.1089 50.6882C39.1089 46.5687 45.0853 37.2306 49.9357 30.7534Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3798 50.6884H53.3198C53.3198 52.556 51.8013 54.0717 49.9364 54.0717V58.1318C51.9099 58.1296 53.8019 57.3447 55.1973 55.9493C56.5928 54.5538 57.3777 52.6618 57.3798 50.6884Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterSupplyActive);
export default __webpack_public_path__ + "static/media/waterSupplyActive.3efba7b2d5c43e8faf4ac7d281047f73.svg";
export { ForwardRef as ReactComponent };